import { render, staticRenderFns } from "./TheHeaderSearch.vue?vue&type=template&id=9985b9ca&scoped=true&"
import script from "./TheHeaderSearch.vue?vue&type=script&lang=js&"
export * from "./TheHeaderSearch.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderSearch.vue?vue&type=style&index=0&id=9985b9ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9985b9ca",
  null
  
)

export default component.exports